<template lang="pug">
.card.market-card.mmo
  .card-header.bg-more-head.collapse-more(
    :id="'heading-hdpoummo-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-hdpoummo-' + childId"
    :aria-controls="'collapse-hdpoummo-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("ui.mmo_odds") }} {{ leagueName.trim() }}
  .collapse.show(
    :aria-labelledby="'heading-hdpoummo-' + childId"
    :id="'collapse-hdpoummo-' + childId"
  )
    .card-body.p-0
      .market-card-content
        .normal
          .normal-odd-area
            .normal-odd-area-group
              .match-bet-area-type-title {{ $tc("m.BT_HDPF", 1) }}
              .d-flex
                .normal-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Home") }}
                template(v-if="Object.keys(source).length > 0 && source['tn'] > 0")
                  template(v-for="(dn, i) in source['tn']")
                    .match-odd-area-group
                      template(v-if="source['mmo']['hdp'] && source['mmo']['hdp'][i] && source['mmo']['hdp'][i][9] != 0 && source['mmo']['hdp'][i][10] != 0 && source['mmo']['hdp'][i][9] != '' && source['mmo']['hdp'][i][10] != ''")
                        oddsItemMMOX(:odds="source['mmo']['hdp'][i]" :idx="source['mmo']['hdp'][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="source['mmo']" homeAway="1" pos=22)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
                .match-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Away") }}
                template(v-if="Object.keys(source).length > 0 && source['tn'] > 0")
                  template(v-for="(dn, i) in source['tn']")
                    .match-odd-area-group
                      template(v-if="source['mmo']['hdp'] && source['mmo']['hdp'][i] && source['mmo']['hdp'][i][9] != 0 && source['mmo']['hdp'][i][10] != 0 && source['mmo']['hdp'][i][9] != '' && source['mmo']['hdp'][i][10] != ''")
                        oddsItemMMOX(:odds="source['mmo']['hdp'][i]" :idx="source['mmo']['hdp'][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="source['mmo']" homeAway="2" pos=22)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
            .normal-odd-area-group
              .match-bet-area-type-title {{ $tc("m.BT_OUF", 1) }}
              .d-flex
                .match-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Over") }}
                template(v-if="Object.keys(source).length > 0 && source['tn'] > 0")
                  template(v-for="(dn, i) in source['tn']")
                    .match-odd-area-group
                      template(v-if="source['mmo']['ou'] && source['mmo']['ou'][i] && source['mmo']['ou'][i][11] != 0 && source['mmo']['ou'][i][12] != 0 && source['mmo']['ou'][i][11] != '' && source['mmo']['ou'][i][12] != ''")
                        oddsItemMMOX(:odds="source['mmo']['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" :details="source['mmo']" homeAway="1" pos=23)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
                .match-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Under") }}
                template(v-if="Object.keys(source).length > 0 && source['tn'] > 0")
                  template(v-for="(dn, i) in source['tn']")
                    .match-odd-area-group
                      template(v-if="source['mmo']['ou'] && source['mmo']['ou'][i] && source['mmo']['ou'][i][11] != 0 && source['mmo']['ou'][i][12] != 0 && source['mmo']['ou'][i][11] != '' && source['mmo']['ou'][i][12] != ''")
                        oddsItemMMOX(:odds="source['mmo']['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="i" :details="source['mmo']" homeAway="2" pos=23)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
</template>

<script>
import oddsItemMMOX from "@/components/mobile/main/xitem/oddsItemMMOX";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    oddsItemMMOX,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    childId: {
      type: Number
    },
    mode: {
      type: Number
    }
  },
  computed: {
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  }
}
</script>